import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpApi from 'i18next-http-backend';

import numbro from 'numbro';
import moment from 'moment';
import 'moment/locale/hr';
import useApi from './lib/api/useApi';

i18n
  .use(HttpApi)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    ns: [
      'core',
      'map',
      'ena',
      'lighting',
      '3D',
      'admin',
      'photo',
      'groblja',
      'nerazvrstane_ceste',
      'rasvjeta',
      'parking',
      'plan_obiljezavanja',
      'chem',
      'prostorni_planovi',
      'pp',
      'cestovna_infrastruktura',
      'koncesije',
      'plin',
      'pristupacnost'
    ],
    defaultNS: 'core',
    fallbackLng: false, // without this, app was setting one of the languages to 'dev' by default resulting in unnecessary requests to API
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    backend: {
      // TODO see on what endpoint will translations be
      loadPath: 'core/translations/{{lng}}/{{ns}}',
      request: (
        options: object,
        url: string,
        payload: object,
        callback: Function
      ) => {
        const apiInstance = useApi();
        return apiInstance
          .get(url)
          .then((resp) => {
            if (resp.success) {
              callback(null, {
                status: 200,
                data: JSON.stringify(resp.data) || '',
              });
            }
          })
          .catch((err) => {
            callback(err);
          });
      },
    },
    react: {
      useSuspense: false,
    },
  });

i18n.on('languageChanged', (lng) => {
  moment.locale(lng);
  numbro.setLanguage(lng);
});

export default i18n;
